import apiService from "../../ApiService";

export const stcRequestOtp = (msisdn: string) => {
  return apiService.post<{ authorizationId: string }>({
    path: `v1/store/stc/ask_otp`,
    body: { msisdn },
  });
};
